import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ContaService } from '@app/services/conta.service';
import { LoadingService } from '@app/services/loading.service';
import { AlertService } from '@services/alert.service';
import { Observable, throwError } from 'rxjs';
import { catchError, tap, timeout } from 'rxjs/operators';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private contaService: ContaService, private loadingSevice: LoadingService, private alertService: AlertService)
  {
  }

  contadorLoading = 0;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const timeoutValue = request.headers.get('timeout') || 60000;
    const timeoutValueNumeric = Number(timeoutValue);

    this.loadingSevice.loadingOn();
    this.contadorLoading++;

    return next.handle(request).pipe(
      timeout(timeoutValueNumeric),
      tap((evento) => {
        if (evento instanceof HttpResponse) {
          this.contadorLoading--;
          if (this.contadorLoading === 0) {
            this.loadingSevice.loadingOff();            
          }
        } 
      }),
      catchError(erro => {
        this.contadorLoading = 0;
        this.loadingSevice.loadingOff();

        if (erro.name == "TimeoutError") {
          var erroTimeout = "Erro: o servidor demorou a responder. Tente novamente em alguns segundos.";
          this.alertService.error(erroTimeout);
          return throwError(erroTimeout);
        }
        else {
          if ([401, 403].includes(erro.status)) {
            // auto logout if 401 or 403 response returned from api
            this.contaService.funcaoEfetuarLogout();
          }
        }

        const errorX = erro?.error?.message || erro?.statusText;
        return throwError(errorX);
      })
    );
  }
}
